import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customPracticeQueueRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-custom-and-issue',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
	query: ['oldIssueView?'],
	exact: true,
};
